export const CALENDAR_TYPES = ['GOOGLE', 'MAC', 'IOS', 'OUTLOOK'];
